<button
  class="td-wb-notification-close-button"
  tdWbIconButton
  tdWbIconButtonSize="extra-small"
  tdWbIconButtonBackground="clear-grey"
  [attr.aria-label]="ariaLabel() | translate"
  (click)="onCloseClick()">
  <td-wb-icon size="12" iconId="close--small" iconType="primary2" />
</button>
